import { __exports as t } from "./index868.mjs";
import { o as r } from "./index820.mjs";
import { e as o } from "./index821.mjs";
var n = r, a = o, s = a.concat("length", "prototype");
t.f = Object.getOwnPropertyNames || function(e) {
  return n(e, s);
};
export {
  t as default
};
